import AsyncStorage from "@react-native-async-storage/async-storage";
import { Fragment, useEffect, useState } from "react";
import {
  ActivityIndicator,
  Image,
  Pressable,
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from "react-native";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { AppBar, EmptyState } from "../components";
import { FlagIcon, CalendarTodayIcon, ChevronRight, PenBold } from "../assets/icons";
import i18n from "../translation/index";
import { checkAnsweredList } from "../services/survey";
import { useNavigation } from "@react-navigation/native";

const ScreeningChooseAnswer = ({ route }) => {
  const { params } = route;
  const { quizId, additionalContentId, isScreening, isNewPractice, isQuick } =
    params;
  const { t } = useTranslation();
  const navigation = useNavigation();
  const [lang, setLang] = useState("id");
  const [loading, setLoading] = useState(true);
  const [dataSource, setDataSource] = useState([]);
  const [memberId, setMemberId] = useState(undefined);
  const [refId, setRefId] = useState(undefined);

  useEffect(() => {
    async function getMember() {
      let theRefId = await AsyncStorage.getItem("refId");
      if (!theRefId) {
        theRefId = md5(new Date().getTime());
        AsyncStorage.setItem("refId", theRefId);
      }
      setRefId(theRefId);

      const memberId = await AsyncStorage.getItem("token");
      setMemberId(memberId);

      return memberId;
    }

    setTimeout(() => {
      getMember();
    }, 1000);
  }, []);

  useEffect(() => {
    if (memberId && refId) {
      setLoading(true);
      checkAnsweredList(params.quizId, memberId, refId)
        .then((res) => {
          if (res?.data) {
            const data = res.data;
            setLoading(false);
            setDataSource(data);
          }
        })
        .catch((err) => {
          setLoading(false);
        });
    }
  }, [memberId, refId]);

  useEffect(() => {
    async function getLang() {
      return await AsyncStorage.getItem("lang");
    }

    getLang().then((res) => {
      if (!res) {
        AsyncStorage.setItem("lang", "id");
        i18n.changeLanguage("id");
        setLang("id");
        return;
      }
      AsyncStorage.setItem("lang", res);
      i18n.changeLanguage(res);
      setLang(res);
    });
  }, []);

  return (
    <Fragment>
      <AppBar title={"Lihat Inputan Saya"} isBack={params?.backButton} />
      {loading ? (
        <View style={styles.loading}>
          <ActivityIndicator color="#6724E2" />
        </View>
      ) : (
        <ScrollView
          contentContainerStyle={{
            gap: 16,
            padding: 16,
            backgroundColor: "#FFF",
            height: dataSource.length === 0 ? "100%" : "auto"
          }}
        >
          {
            dataSource.length === 0 && (
              <View style={{ alignItems: "center", height: "100%" }}>
                {/* <PenBold color="#6724E2" size={24} /> */}
                <EmptyState
            Icon={PenBold}
            title={"Belum ada data tersimpan"}
            desc={"Data yang sudah Anda simpan sebelumnya akan muncul di halaman ini"}
          />
              </View>
            )
          }
          {dataSource?.map((item) => {
            return (
              <View
                key={item?.id}
                style={{
                  borderWidth: 1,
                  borderColor: "#EAEAEA",
                  borderRadius: 10,
                  padding: 15,
                  gap: 15,
                }}
              >
                <View
                  style={{
                    flex: 1,
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 10,
                  }}
                >
                  <FlagIcon />
                  <Text>Info</Text>
                </View>
                <View style={{ paddingBottom: 5 }}>
                  <Text style={{ color: "#4EB826", fontWeight: 700 }}>
                    {item.chosenAnswer}
                  </Text>
                </View>
                <View
                  style={{
                    flex: 1,
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 10,
                  }}
                >
                  <CalendarTodayIcon />
                  <Text>Tanggal Input</Text>
                </View>
                <View
                  style={{
                    display: "flex",
                    flex: 1,
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Text style={{ color: "#000" }}>
                    {moment
                      .utc(item.created)
                      .local()
                      .locale(lang)
                      .format(
                        lang === "id"
                          ? "ddd, DD MMM YYYY, [Pukul] HH:mm"
                          : "ddd, DD MMM YYYY, hh:mm A",
                      )}
                  </Text>
                  <TouchableOpacity
                    style={{
                      flex: 1,
                      display: "flex",
                      justifyContent: "flex-end",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: 10,
                    }}
                    onPress={() => {
                      navigation.navigate("SurveyDetail", {
                        quizId,
                        additionalContentId,
                        isScreening,
                        isNewPractice,
                        isQuick,
                        isChoosen: true,
                        created: item.created,
                        version: new Date().getTime(),
                      });
                    }}
                  >
                    <Text style={{ fontWeight: 600, color: "#6724E2" }}>
                      Lihat
                    </Text>
                    <ChevronRight fill="#6724E2" />
                  </TouchableOpacity>
                </View>
              </View>
            );
          })}
        </ScrollView>
      )}
    </Fragment>
  );
};
const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 16,
    backgroundColor: "#EEEAFF",
  },
  headerBox: {
    backgroundColor: "#fff",
    paddingHorizontal: 16,
    paddingTop: 16,
    paddingBottom: 10,
    borderBottomLeftRadius: 10,
    borderBottomRightRadius: 10,
  },
  image: {
    width: "100%",
    height: 61,
    borderRadius: 10,
    resizeMode: "cover",
  },
  title: {
    fontFamily: "Archivo-SemiBold",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: 14,
    lineHeight: 15,
    marginTop: 16,
    marginBottom: 10,
  },
  desc: {
    fontFamily: "Archivo-Regular",
    fontStyle: "normal",
    fontWeight: "400",
    fontSize: 13,
    lineHeight: 16,
  },
  loading: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#EEEAFF",
  },
});

export default ScreeningChooseAnswer;
